import { GetUserZone, SaveUserZone, ValidateUserZone, ValidateZone } from './Zones'
import { SaveGame, DeleteGame } from './Games'


const ShowSectionsView = async (urlParameter) => {
    try {
        // Ruta obtenida de la URL
        let utmZone = urlParameter || null
        if (!utmZone) {
            // Obtener zona guardada de sessionStorage
            
            const response = await GetUserZone()
            
            if (response.success) {
                utmZone = response.data?.text || response.data
            }
        }
        
        if (utmZone) {
            const responseSaveUser = await SaveUserZone(utmZone)
            
            if (responseSaveUser.success) {
                return { success: true, data: responseSaveUser.data }
            } else {
                return { success: false, message: null }
            }
        } else {
            return { success: false, message: null }
        }
        
        // if (zoneData) {
        //     debugger
        //     const responseSaveUser = await SaveUserZone(utmZone)
        //     debugger
        //     if (responseSaveUser.success) {
        //         return { success: true, data: responseSaveUser.data }
        //     } else {
        //         return { success: false, message: null }
        //     }
        // } else {
        //     return { success: false, message: null }
        // }


        // // Si hay utm_source → intentar guardar como zona
        // if (utmZone !== null) {
        //     const response = await SaveUserZone(utmZone)

        //     if (response.success) {
        //         return { success: true, data: response.data }
        //     }
        // }

        // // Si no hay utm_source o no se pudo guardar → validar si ya hay zona guardada
        // const response = await ValidateUserZone()
        
        // if (response.success) {
        //     return { success: true, data: response.data }
        // } else {
        //     return { success: false, message: null }
        // }
    } catch (error) {
        return { success: false, message: '' }
    }
}

const SaveGameToShow = async (idGame) => {
    try {
        const gameData = {
            id: idGame,
            name: null
        }
        
        const response = await SaveGame(gameData)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: null }
        }
    } catch (error) {
        return { success: false, message: '' }
    }
}

const DeleteGameToShow = async () => {
    try {
        const response = await DeleteGame()
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: null }
        }
    } catch (error) {
        return { success: false, message: '' }
    }
}

export { ShowSectionsView, SaveGameToShow, DeleteGameToShow };